export let LOADERS: any = {};

const loaderFiles = require.context('./loaders', false, /.ts$/)

loaderFiles.keys().forEach(key => {
  LOADERS = { ...LOADERS, ...loaderFiles(key).default || loaderFiles(key)}
})
